export enum SettingsEnum{
  primary="primary",
  navheaderBg="nav-headerBg",
  headerBg="headerBg",
  sidebarBg="sidebarBg",
  layout="layout",
  sidebarPosition="sidebar-position",
  sidebarStyle="sidebar-style",
  headerPosition="header-position",
  themeVersion="theme-version",
  twoFactor="two_factor"
}

export enum TwoFactorEnum{
  sms="SMS",
  authenticator='Authenticator',
  email="Email"
}
